import { render, staticRenderFns } from "./GroceryListingsSectionModule.vue?vue&type=template&id=d09226f2&"
import script from "./GroceryListingsSectionModule.vue?vue&type=script&lang=js&"
export * from "./GroceryListingsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports